export default __webpack_public_path__ + "static/media/BrainBreak cards107.a98ed79c.png";